/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getStampAssets} from '../api'

 export const useQueryGetStampAssets = createReactQueryHook('getStampAssets', getStampAssets)
